import { BASE_URL } from '../../general/variables';
import { showEditModal, getAssignedNames, updateDataStatus, getRecID } from './_functions';
import { databaseTable, databaseTableAds, editValidation, processFirebase } from './_setup';
import { buttonLoader, makeKTBlock } from '../../general/functions';

const archiveStudentData = async function (students, status) {
  let curAlert = new Swal({
    title: 'Processing data, please wait',
    showLoaderOnConfirm: true,
    showConfirmButton: false,
    showCancelButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    onBeforeOpen: () => {
      Swal.showLoading();
    },
    preConfirm: () => {
      return false;
    },
  });

  try {
    let curStatus = await updateDataStatus(getRecID(students), status);

    if (curStatus.code == 200) {
      curAlert.update({
        title: 'Process Completed',
        icon: 'success',
        html: 'Selected data has been archived!',
        showCancelButton: false,
        confirmButtonText: 'Close',
        allowOutsideClick: true,
        allowEscapeKey: true,
      });

      databaseTable.reload();
    } else {
      curAlert.update({
        title: 'Incomplete Process',
        icon: 'warning',
        html: 'Cannot complete process! Please contact IT for more details',
        showCancelButton: false,
        confirmButtonText: 'Close',
        allowOutsideClick: true,
        allowEscapeKey: true,
      });
    }
  } catch (err) {
    console.log(`Unkown error has occured`, err);

    curAlert.update({
      title: 'Unkown error has occured',
      icon: 'error',
      html: 'Cannot process data! Please contact IT for more details',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: true,
      allowEscapeKey: true,
    });
  }

  KTApp.unblock('#databaseCard');
  KTApp.unblock('#filterCard');
};

const assignedStudentData = function (list, length, assCounsellor, assLocation) {
  let curCount = 0;
  let deferred = $.Deferred();

  let curRes = {
    error: 0,
    errorList: [],
    success: 0,
    successList: [],
    type: '',
  };

  // Initialize SweetAlert2 with a loading message
  let curSwal = Swal.fire({
    title: 'Processing Students...',
    text: `Please wait while processing ${curCount} students from ${length}.`,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    onBeforeOpen: () => {
      Swal.showLoading();
      processData();
    },
  });

  function processData() {
    $.ajax({
      url: BASE_URL + 'DatabaseController/updateAssignedStatus',
      method: 'POST',
      async: true,
      data: {
        students: list[curCount],
        assigned: assCounsellor,
        assigned_loc: assLocation,
      },
      success: function (resp) {
        curCount++;

        curRes.type = resp.type;

        if (resp.code == 200) {
          curRes.success = curRes.success + 1;
          curRes.successList.push(resp.details);
        } else {
          curRes.error = curRes.error + 1;
          curRes.errorList.push(resp.details);
        }

        if (curCount < length) {
          processData();

          curSwal.update({
            title: 'Processing Students...',
            text: `Please wait while processing ${curCount + 1} students from ${length}`,
          });
        } else {
          // Resolve the deferred object with true when all data is processed successfully

          curSwal.close();

          deferred.resolve({
            status: true,
            data: curRes,
            type: curRes.type,
          });
        }
      },
      error: function (_resp) {
        // Resolve the deferred object with false in case of an error for a specific student
        deferred.resolve(false);
      },
    });
  }

  // Return the promise object
  return deferred.promise();
};

const filterTableListener = function () {
  $('.query-filter').on('change', function () {
    let curFilter = $(this);

    let arrForm = ['SELECT', 'INPUT'];

    if (arrForm.includes(curFilter.prop('nodeName'))) {
      if ($('#filterCard').length) {
        makeKTBlock('#filterCard');
      }

      if ($('#databaseTable').length) {
        makeKTBlock('#databaseTable');

        if (curFilter.attr('type') == 'checkbox') {
          if (curFilter.is(':checked')) {
            databaseTable.search('CHECKED', curFilter.attr('data-filter'));
          } else {
            databaseTable.search('UNCHECKED', curFilter.attr('data-filter'));
          }
        } else {
          databaseTable.search(curFilter.val(), curFilter.attr('data-filter'));
        }
      } else if ($('#databaseTableAds').length) {
        makeKTBlock('#databaseTableAds');
        let param = {};

        $('.query-filter').each(function (i, elem) {
          let elemData = $(elem).attr('data-filter');

          console.log($(elem).attr('data-filter'));
          if (elemData && $(elem).val() != '' && $(elem).val() != undefined) {
            if ($(elem).attr('type') == 'checkbox') {
              if ($(elem).is(':checked')) {
                param[elemData] = 'CHECKED';
              } else {
                param[elemData] = 'UNCHECKED';
                delete param[elemData];
              }
            } else if (['CREATED_START', 'CREATED_END'].includes(elemData)) {
              if (elemData == 'CREATED_START') {
                const startVal = $(elem).val();
                const $endInput = $('input[name="dataCreateEnd"]');
                const endVal = $endInput.val();

                // Set min date to CREATED_END input
                $endInput.attr('min', startVal);

                // Only auto-fill end date if it's empty or before start date
                if (!endVal || new Date(endVal) < new Date(startVal)) {
                  $endInput.val(startVal);
                }
              }

              param['CREATED_START'] = $('input[name="dataCreateStart"]').val();
              param['CREATED_END'] = $('input[name="dataCreateEnd"]').val();
            } else {
              param[elemData] = $(elem).val();
            }
          }
        });

        $(`#databaseTableAds`).data('param', param);
        $(`#databaseTableAds`).DataTable().draw();
      }
    }
  });
};

const actionButtonListener = function () {
  $('.btn-database-actions').on('click', function (evt) {
    $(`#consultationDatePicker_0`).datetimepicker();

    evt.preventDefault();

    const curBtn = $(this);
    const curSelected = databaseTable.getSelectedRecords();

    KTApp.block('#databaseCard', {
      opacity: 0.1,
      state: 'primary',
    });

    KTApp.block('#filterCard', {
      opacity: 0.1,
      state: 'primary',
    });

    if (curSelected.length == 0) {
      Swal.fire({
        icon: 'warning',
        html: 'Please select at <strong>least one record</strong> to continue!',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });

      KTApp.unblock('#databaseCard');
      KTApp.unblock('#filterCard');

      return;
    }

    let curCounsellor = '',
      curBranch = '';

    curCounsellor = $('[name="slc_assigned_counsellor"]:visible');
    curBranch = $('[name="slc_assigned_location"]:visible');

    curCounsellor.find('option').text();

    switch (curBtn.attr('data-action')) {
      case 'ASSIGN':
        // Validasi counsellor & cabang
        if (curCounsellor.val() == '' && (curBranch.val() == '' || curBranch.length == 0)) {
          Swal.fire({
            icon: 'warning',
            html: `Please select <strong>COUNSELLOR</strong> or <strong>BRANCH</strong> to continue`,
            confirmButtonText: 'Close',
            showCancelButton: false,
          }).then((_res) => {
            KTApp.unblock('#databaseCard');
            KTApp.unblock('#filterCard');
          });

          return;
        }

        const curNames = getAssignedNames(curSelected);
        let curAssignees = '';

        if (curBranch.val() == null) {
          curAssignees = curCounsellor.find('option:selected').text();
        } else if (curCounsellor.val() == '') {
          curAssignees = curBranch.find('option:selected').text();
        } else {
          curAssignees = curCounsellor.find('option:selected').text();
        }

        Swal.fire({
          icon: 'warning',
          html: `Are you sure you want to <strong>ASSIGNED</strong> selected data(s) to <strong>${curAssignees}</strong>? <br/> <br/>
                            ${curNames}<br/>
                            This process <strong>cannot be reversed</strong>!`,
          confirmButtonText: 'Assign',
          showCancelButton: true,
          cancelButtonText: 'Close',
        }).then((res) => {
          if (res.isConfirmed) {
            assignedStudentData(getRecID(curSelected), getRecID(curSelected).length, curCounsellor.val(), curBranch == null ? null : curBranch.val())
              .then(function (res) {
                // Kalau update cabang, langsung tampilin Swal aja
                if (res.type == 'BRANCH') {
                  Swal.fire({
                    icon: 'success',
                    html: 'Student branch updated successfully',
                    confirmButtonText: 'Close',
                    showCancelButton: false,
                  });

                  KTApp.unblock('#databaseCard');
                  KTApp.unblock('#filterCard');

                  curCounsellor.val('').selectpicker('refresh');

                  curBranch.val('').selectpicker('refresh');

                  databaseTable.reload();

                  return;
                } else {
                  let resp = res.data;

                  $('#studentErrorHolder').html('');

                  $('#studentSuccessHolder').html('');

                  if (!res.status) {
                    Swal.fire({
                      icon: 'error',
                      html: 'Cannot process data, please contact IT for more info',
                      confirmButtonText: 'Close',
                      showCancelButton: false,
                    });

                    KTApp.unblock('#databaseCard');
                    KTApp.unblock('#filterCard');

                    return;
                  }

                  // Buat semua daftar error
                  if (resp.error == 0) {
                    $('#cardAssignError').addClass('d-none');
                  } else {
                    $('#cardAssignError').removeClass('d-none');

                    $('#studentErrorCounter').html(`${resp.error} Duplicate(s) Found <small>Duplicates are written in <span>red</span></small>`);

                    for (let i = 0; i < resp.errorList.length; i++) {
                      let $listEntry = $(` <div class="my-5 min-w-245px mr-5">
                                              <div>
                                                  ${resp.errorList[i].ORIGINAL.name} - ${resp.errorList[i].DUPLICATE.status}
                                              </div>
                                              <div>
                                                <i class="fa fas fa-phone pr-2 border-right"></i> 
                                                <span class="font-weight-bold student-monitoring-tooltip" data-toggle="tooltip" data-theme="dark" title="Student monitoring data">${resp.errorList[i].ORIGINAL.phone}</span> 
                                                <span class="text-danger font-weight-bold student-monitoring-tooltip" data-toggle="tooltip" data-theme="dark" title="Database data">${resp.errorList[i].DUPLICATE.phone}</span>
                                              </div>
                                              <div>
                                                <i class="fa fa-envelope-open-text pr-2 border-right"></i>  
                                                <span class="font-weight-bold student-monitoring-tooltip" data-toggle="tooltip" data-theme="dark" title="Student monitoring data">${resp.errorList[i].ORIGINAL.email}</span> 
                                                <span class="text-danger font-weight-bold student-monitoring-tooltip" data-toggle="tooltip" data-theme="dark" title="Database data">${resp.errorList[i].DUPLICATE.email}</span>
                                              </div>
                                              <div>
                                                  Handled by: <span class="font-weight-bold">${resp.errorList[i].DUPLICATE.counsellor}</span>
                                              </div>
                                              <div>
                                                  Record ID: <span class="font-weight-bold">${resp.errorList[i].DUPLICATE.record}</span>
                                              </div>
                                            </div>`);

                      $('#studentErrorHolder').append($listEntry);
                    }
                  }

                  if (resp.success == 0) {
                    $('#cardAssignSuccess').addClass('d-none');

                    $('#studentSuccessHolder').html('');
                  } else {
                    $('#cardAssignSuccess').removeClass('d-none');

                    $('#studentSuccessCounter').html(`${resp.success} New Entry Created`);

                    for (let j = 0; j < resp.successList.length; j++) {
                      let $listEntry = $(`<div class="my-5 min-w-245px mr-5 text-center">
                                            <div>
                                                <span class="font-weight-bold">${resp.successList[j].ENTRY.name}</span>
                                            </div>
                                            <a class="btn btn-sm btn-light-primary font-weight-bold mt-3" href="${BASE_URL}leads/detail?id=${resp.successList[j].ENTRY.id}" target="_blank">View Details</a>
                                        </div>`);

                      $('#studentSuccessHolder').append($listEntry);
                    }
                  }

                  $('#modalAssignError').tooltip({
                    selector: '.student-monitoring-tooltip',
                    trigger: 'click',
                  });

                  $('#modalAssignError').modal('show');
                }

                databaseTable.reload();
              })
              .fail(function (err) {
                Swal.fire({
                  icon: 'error',
                  html: 'Cannot process data, please contact IT for more info',
                  confirmButtonText: 'Close',
                  showCancelButton: false,
                });

                console.log('cannot process', err);
              });

            KTApp.unblock('#databaseCard');
            KTApp.unblock('#filterCard');
          } else {
            KTApp.unblock('#databaseCard');
            KTApp.unblock('#filterCard');

            return;
          }
        });

        break;

      case 'ARCHIVE':
        Swal.fire({
          icon: 'warning',
          html: `Are you sure you want to <strong>ARCHIVE</strong> selected data?`,
          confirmButtonText: 'Yes',
          showCancelButton: true,
          cancelButtonText: 'Close',
        }).then((res) => {
          if (res.isConfirmed) {
            archiveStudentData(curSelected, 'ARCHIVED');
          } else {
            KTApp.unblock('#databaseCard');
            KTApp.unblock('#filterCard');
          }
        });

        break;

      case 'EDIT':
        if (curSelected.length > 1) {
          Swal.fire({
            icon: 'warning',
            html: `Cannot edit <strong>multiple data</strong>! Please select one (1) record to continue`,
            confirmButtonText: 'Close',
            showCancelButton: false,
          });
        } else {
          showEditModal(curSelected);
        }

        KTApp.unblock('#databaseCard');
        KTApp.unblock('#filterCard');

        break;

      case 'BOOK_CONSULTATION':
        const container = $('#modalConsultationBooking #consultationFormRow');
        const template = $('#modalConsultationBooking #consultationFormTemplate');

        container.find('.student-list').not('#consultationFormTemplate').remove();

        for (let i = 0; i < curSelected.length; i++) {
          const stdObj = {
            ID: null,
            NAME: null,
            PHONE: null,
            EMAIL: null,
            BRANCH: null,
          };

          const curRow = $(curSelected[i]).children('[data-field="NAME"]');

          stdObj.NAME = $(curRow).attr('aria-label');

          stdObj.ID = $(curRow).find('[data-type="REC_ID"]').attr('data-value');
          stdObj.PHONE = $(curRow).find('[data-type="PHONE"]').attr('data-value');
          stdObj.EMAIL = $(curRow).find('[data-type="EMAIL"]').attr('data-value');
          stdObj.BRANCH = $(curRow).find('[data-type="BRANCH"]').attr('data-value');

          const cloneEl = template.clone().removeAttr('id').removeClass('d-none').addClass('student-list');

          cloneEl.find('input[name="consultationBookingName"]').val(stdObj.NAME);
          cloneEl.find('input[name="consultationContactBookingDetails"]').val(stdObj.PHONE + ' / ' + stdObj.EMAIL);
          cloneEl.find('select[name="consultationBranch[]"]').val(stdObj.BRANCH);
          cloneEl.find('input[name="consultationID[]"]').val(stdObj.ID);

          container.append(cloneEl);

          cloneEl.find('select').addClass('selectpicker').selectpicker('render');
        }

        $('#modalConsultationBooking').modal('show');

        KTApp.unblock('#databaseCard');
        KTApp.unblock('#filterCard');

        break;

      case 'UNARCHIVE':
        Swal.fire({
          icon: 'warning',
          html: `Are you sure you want to <strong>UNARCHIVE</strong> selected data?`,
          confirmButtonText: 'Yes',
          showCancelButton: true,
          cancelButtonText: 'Close',
        }).then((res) => {
          if (res.isConfirmed) {
            archiveStudentData(curSelected, 'UNARCHIVE');
          } else {
            KTApp.unblock('#databaseCard');
            KTApp.unblock('#filterCard');
          }
        });

        break;
    }
  });
};

const buttonExportListener = function () {
  $('#btnExportExcel').on('click', function (evt) {
    evt.preventDefault();
    var filters;

    if ($('#databaseTable').length) {
      makeKTBlock('#databaseCard');
      filters = databaseTable.getDataSourceParam('query');
    } else if ($('#databaseTableAds').length) {
      makeKTBlock('#databaseTableAds');
      filters = $('#databaseTableAds').DataTable().ajax.params();
    }
    makeKTBlock('#filterCard');

    let curAlert = new Swal({
      title: 'Exporting data, please wait',
      showLoaderOnConfirm: true,
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      preConfirm: () => {
        return false;
      },
    });

    $.ajax({
      url: BASE_URL + 'DatabaseController/exportDatabase',
      method: 'POST',
      dataType: 'JSON',
      data: {
        filters: JSON.stringify(filters),
      },
      error: function (data) {
        curAlert.update({
          title: 'Unkown error has occured',
          icon: 'error',
          html: 'Cannot process data! Please contact IT for more details',
          showCancelButton: false,
          confirmButtonText: 'Close',
          allowOutsideClick: true,
          allowEscapeKey: true,
        });

        if ($('#databaseTable').length) {
          makeKTBlock('#databaseCard', 'hide');
        } else if ($('#databaseTableAds').length) {
          makeKTBlock('#databaseTableAds', 'hide');
        }
        makeKTBlock('#filterCard', 'hide');
      },
    }).done(function (data) {
      if (data.code == 204) {
        curAlert.update({
          title: 'Unkown error has occured',
          icon: 'error',
          html: 'Cannot process data! Please contact IT for more details',
          showCancelButton: false,
          confirmButtonText: 'Close',
          allowOutsideClick: true,
          allowEscapeKey: true,
        });

        if ($('#databaseTable').length) {
          makeKTBlock('#databaseCard', 'hide');
        } else if ($('#databaseTableAds').length) {
          makeKTBlock('#databaseTableAds', 'hide');
        }
        makeKTBlock('#filterCard', 'hide');

        return;
      } else {
        let curDate = new Date();
        let $a = $('<a>').attr('href', data.file);

        $('body').append($a);
        $a.attr('download', `Export Database - ${curDate.getDate() + '-' + curDate.getMonth() + '-' + curDate.getFullYear()}.xlsx`);
        $a[0].click();
        $a.remove();

        curAlert.close();

        if ($('#databaseTable').length) {
          makeKTBlock('#databaseCard', 'hide');
        } else if ($('#databaseTableAds').length) {
          makeKTBlock('#databaseTableAds', 'hide');
        }
        makeKTBlock('#filterCard', 'hide');
      }
    });
  });
};

const editModalListener = function () {
  $('#editDatabaseModal').on('shown.bs.modal', function () {
    // Select2 untuk edit sekolah
    $('#editDatabaseModal #editStudentSchool').select2({
      placeholder: 'Previous School / University',
      language: {
        inputTooShort: function (args) {
          // args.minimum is the minimum required length
          // args.input is the user-typed text
          return 'Please enter ' + args.minimum + ' characters to start searching';
        },
        errorLoading: function () {
          return 'Error loading results';
        },
        loadingMore: function () {
          return 'Loading more results';
        },
        noResults: function () {
          return 'No results found';
        },
        searching: function () {
          return 'Searching school...';
        },
        maximumSelected: function (args) {
          // args.maximum is the maximum number of items the user may select
          return 'Error loading results';
        },
      },
      ajax: {
        url: BASE_URL + 'School/getMonitoringSchoolList',
        delay: 300,
        data: function (params) {
          return {
            q: params.term,
          };
        },
      },
      dropdownCssClass: 'edits',
      minimumInputLength: 3,
      escapeMarkup: function (markup) {
        return markup;
      },
    })
  })

  $('#editDatabaseModal #editDatabase').on('submit', function (evt) {
    evt.preventDefault();

    let curForm = $('#editDatabaseModal #editDatabase');
    let curButton = curForm.find('button[type="submit"]');

    editValidation.validate().then(function (status) {
      if (status == 'Valid') {
        buttonLoader(curButton, 'loading', null);
        curForm[0].submit();
      } else {
        buttonLoader(curButton, 'failed', 'Save changes');
      }
    });
  });

  $('#btnBookConsultation').on('click', function () {
    makeKTBlock('#modalConsultationBooking');

    let curStatus = true;

    const curForm = {
      branch: [],
      type: [],
      date: [],
      id: [],
      notes: [],
    };

    $('.student-list select[name="consultationBranch[]"]:visible').each(function () {
      if ($(this).val().trim() === '') {
        curStatus = false;
        $(this).addClass('is-invalid');
      } else {
        curForm.branch.push($(this).val().trim());
        $(this).removeClass('is-invalid');
      }
    });

    $('.student-list select[name="consultationType[]"]:visible').each(function () {
      if ($(this).val().trim() === '') {
        curStatus = false;
        $(this).addClass('is-invalid');
      } else {
        curForm.type.push($(this).val().trim());
        $(this).removeClass('is-invalid');
      }
    });

    $('.student-list input[name="consultationBookingDate[]"]:visible').each(function () {
      if ($(this).val().trim() === '') {
        curStatus = false;
        $(this).addClass('is-invalid');
      } else {
        curForm.date.push($(this).val().trim());
        $(this).removeClass('is-invalid');
      }
    });

    $('.student-list textarea[name="consultationNotes[]"]:visible').each(function () {
      if ($(this).val().trim() === '') {
        curStatus = false;
        $(this).addClass('is-invalid');
      } else {
        curForm.notes.push($(this).val().trim());
        $(this).removeClass('is-invalid');
      }
    });

    $('.student-list input[name="consultationID[]"]').each(function () {
      curForm.id.push($(this).val());
    });

    if (curStatus) {
      $.post(BASE_URL + 'DatabaseController/postBookingConsultation', curForm)
        .done(async (res) => {
          makeKTBlock('#modalConsultationBooking', 'hide');
          if (res.code == 200) {
            /** Insert ke firebase */
            try {
              if (res?.dupe_log?.data?.length >= 1) {
                $('#studentErrorTitle').text($('#modalAssignError').data('title-bookconsul'));
                $('#studentNotesHolder').hide();
              } else {
                $('#studentErrorTitle').text($('#modalAssignError').data('title-default'));
                $('#studentNotesHolder').show();
              }

              $('#studentErrorHolder').html('');
              if (res?.dupe_log?.error >= 1) {
                $('#studentErrorCounter').html(`${res.dupe_log.error} Duplicate(s) Found <small class="text-danger">(Duplicates are written in <span class="fw-bolder">red</span>)</small>`);

                let dupeArr = res.dupe_log.data;
                for (let i = 0; i < dupeArr.length; i++) {
                  let $listEntry = $(`
                    <div class="my-5 min-w-245px mr-5">
                      <div class="fw-bold text-dark">
                          ${dupeArr[i].ORIGINAL.name}
                      </div>
                      <div>
                        <i class="fa fas fa-phone pr-2 border-right"></i>
                        <span class="font-weight-bold student-monitoring-tooltip cursor-pointer" data-toggle="tooltip" data-theme="dark" title="Student monitoring data">${dupeArr[i].ORIGINAL.phone}</span>
                        <span class="text-danger font-weight-bold student-monitoring-tooltip cursor-pointer" data-toggle="tooltip" data-theme="dark" title="Database data">${dupeArr[i].DUPLICATE.phone}</span>
                      </div>
                      <div>
                        <i class="fa fa-envelope-open-text pr-2 border-right"></i>
                        <span class="font-weight-bold student-monitoring-tooltip cursor-pointer" data-toggle="tooltip" data-theme="dark" title="Student monitoring data">${dupeArr[i].ORIGINAL.email}</span>
                        <span class="text-danger font-weight-bold student-monitoring-tooltip cursor-pointer" data-toggle="tooltip" data-theme="dark" title="Database data">${dupeArr[i].DUPLICATE.email}</span>
                      </div>
                      <div>
                          Handled by:
                          <span class="ml-2 font-weight-bold">${dupeArr[i].DUPLICATE.counsellor}</span>
                      </div>
                      <div class="d-flex flex-start">
                          Record ID:
                          <span class="font-weight-bold ml-2">
                            ${dupeArr[i].DUPLICATE.record}
                          </span>
                          ${dupeArr[i].DUPLICATE.record ? `<span class="font-weight-bold"><a class="ml-2 label label-inline label-sm label-light-primary" href="${BASE_URL}leads/detail?id=${dupeArr[i].DUPLICATE.record}" target="_blank">View Student</a></span>` : ''}
                      </div>
                    </div>
                  `);

                  $('#studentErrorHolder').append($listEntry);
                }

                $('#modalAssignError').tooltip({
                  selector: '.student-monitoring-tooltip',
                  trigger: 'click',
                });

                $('#modalAssignError').modal('show');
              } else {
                $('#cardAssignError').hide();
              }

              $('#studentSuccessCounter').html('');
              if (res?.dupe_log?.success >= 1) {
                $('#studentSuccessCounter').html(`${res.dupe_log.success} Data entry(s) successfully booked!`);
              } else {
                $('#cardAssignSuccess').hide();
              }

              if (res?.data?.length != 0) {
                let updateAct = {
                  data: [],
                },
                  firebaseID;
                for (let i = 0; i < res.data.length; i++) {
                  firebaseID = await processFirebase({
                    targetNIP: res.data[i].counsellor,
                    targetName: res.data[i].counsellorName,
                    creatorSN: res.data[i].creatorSN,
                    creatorName: res.data[i].creatorName,
                    actID: res.data[i].actID,
                    studentID: res.data[i].student,
                    actNotes: res.data[i].actNotes,
                    categories: res.data[i].categories,
                  });

                  updateAct.data.push({
                    firebase_id: firebaseID,
                    rec_id: res.data[i].actID, // adjust key if different
                  });
                }

                console.log(updateAct);
                $.post(`${BASE_URL}Activities/updateActFirebaseID`, updateAct)
                  .done((response) => {
                    console.log(response);
                    makeKTBlock('#modalConsultationBooking', 'hide');
                  })
                  .fail((errs) => {
                    console.log('something wrong when update firebase id', errs);
                    makeKTBlock('#modalConsultationBooking', 'hide');
                  });

                if (res.dupe_log.error == 0) {
                  await Swal.fire({
                    title: 'Consultation Booked!',
                    icon: 'success',
                    confirmButtonText: 'Close',
                    showCancelButton: false,
                  });
                }
              }

              $('#modalConsultationBooking').modal('hide');

              makeKTBlock('#databaseTable');
              databaseTable.reload();

              makeKTBlock('#modalConsultationBooking', 'hide');
            } catch (err) {
              console.log('Error occured', err);

              await Swal.fire({
                icon: 'warning',
                html: 'Cannot complete process! Please try again later',
                confirmButtonText: 'Close',
                showCancelButton: false,
              });

              makeKTBlock('#modalConsultationBooking', 'hide');
            }
          } else {
            Swal.fire({
              icon: 'warning',
              html: 'Cannot complete process! Please try again later',
              confirmButtonText: 'Close',
              showCancelButton: false,
            });
          }
        })
        .fail((err) => {
          console.log('something wrong', err);
          makeKTBlock('#modalConsultationBooking', 'hide');
        });
    } else {
      makeKTBlock('#modalConsultationBooking', 'hide');
    }
  });

  $('#modalAssignError').on('hidden.bs.modal', function (e) {
    e.preventDefault();

    $('#studentErrorTitle').text($('#modalAssignError').data('title-default'));
    $('#studentNotesHolder, #cardAssignError, #cardAssignSuccess').show();
  });
};

export { filterTableListener, actionButtonListener, editModalListener, buttonExportListener };
